import React from 'react';
import styles from './componentCss/TitleBanner.module.css';
import Button from './Button';
import { ArrowRight } from 'lucide-react';

const TitleBanner = ({
    imageSrc,
    title,
    button,
    textColor,
    withShadow = true,
    height,
    marginTop,          // new prop
}) => {
    const titleStyle = {
        color: textColor,
    };

    const bannerStyle = {
        height,
        marginTop,       // apply marginTop here, can be negative
    };

    const titleClass = withShadow
        ? `${styles.title} ${styles.shadow}`
        : styles.title;

    return (
        <div className={styles.banner} style={bannerStyle}>
            {/*<img src={imageSrc} alt="banner" className={styles.image} />*/}
            <div className={styles.overlay}>
                <h1 className={titleClass} style={titleStyle}>
                    {title}
                </h1>
                {button && (
                    <div className={styles.buttonContainer}>
                        <Button
                            href={button.href}
                            type="button"
                            backgroundColor="#0078D4"
                            height={50}
                            fontSize={button.fontSize || '1rem'}
                        >
                            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                {button.label}
                                <ArrowRight size={18} style={{ marginLeft: '8px' }} />
                            </span>
                        </Button>

                    </div>
                )}
            </div>
        </div>
    );
};

export default TitleBanner;
